import React, { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000'
const TEAL = '#0d9488'
const FONT = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"

export default function ResetPassword({ token }) {
  const [status, setStatus] = useState('loading') // loading | ready | submitting | done | error
  const [form, setForm] = useState({ password: '', confirmPassword: '' })
  const [error, setError] = useState('')

  useEffect(() => {
    axios.get(`${API}/auth/reset-password/${token}`)
      .then(() => setStatus('ready'))
      .catch(err => {
        setError(err.response?.data?.detail || 'This link is invalid or has expired.')
        setStatus('error')
      })
  }, [token])

  const handleSubmit = () => {
    setError('')
    if (!form.password || !form.confirmPassword) { setError('Please fill in both fields.'); return }
    if (form.password !== form.confirmPassword) { setError('Passwords do not match.'); return }
    if (form.password.length < 6) { setError('Password must be at least 6 characters.'); return }
    setStatus('submitting')
    axios.post(`${API}/auth/reset-password`, { token, new_password: form.password })
      .then(() => setStatus('done'))
      .catch(err => { setError(err.response?.data?.detail || 'Something went wrong.'); setStatus('ready') })
  }

  return (
    <div style={{ minHeight: '100vh', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: FONT }}>
      <div style={{ width: '100%', maxWidth: '420px', background: 'white', borderRadius: '16px', padding: '36px 32px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0' }}>

        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ fontSize: '20px', fontWeight: '800', color: TEAL, marginBottom: '4px' }}>ClearPath PT</div>
          <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#0f172a', margin: '0 0 4px' }}>Reset Password</h1>
        </div>

        {status === 'loading' && <p style={{ textAlign: 'center', color: '#64748b' }}>Verifying link...</p>}

        {status === 'error' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}></div>
            <p style={{ color: '#dc2626', fontSize: '15px' }}>{error}</p>
            <a href="/login" style={{ color: TEAL, fontSize: '14px', fontWeight: '500' }}>← Back to sign in</a>
          </div>
        )}

        {(status === 'ready' || status === 'submitting') && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={lS}>New Password</label>
              <input type="password" placeholder="At least 6 characters" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} style={iS} />
            </div>
            <div>
              <label style={lS}>Confirm Password</label>
              <input type="password" placeholder="Re-enter new password" value={form.confirmPassword} onChange={e => setForm(f => ({ ...f, confirmPassword: e.target.value }))} onKeyPress={e => e.key === 'Enter' && handleSubmit()} style={iS} />
            </div>
            {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '11px 14px', fontSize: '14px', color: '#dc2626' }}>{error}</div>}
            <button onClick={handleSubmit} disabled={status === 'submitting'} style={{ padding: '13px', backgroundColor: status === 'submitting' ? '#94a3b8' : TEAL, color: 'white', border: 'none', borderRadius: '8px', cursor: status === 'submitting' ? 'default' : 'pointer', fontSize: '16px', fontWeight: '600', fontFamily: FONT, opacity: status === 'submitting' ? 0.7 : 1 }}>
              {status === 'submitting' ? 'Updating...' : 'Set New Password'}
            </button>
          </div>
        )}

        {status === 'done' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}></div>
            <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#0f172a', marginBottom: '8px' }}>Password updated!</h2>
            <p style={{ color: '#64748b', fontSize: '15px', marginBottom: '24px' }}>You can now sign in with your new password.</p>
            <a href="/login" style={{ display: 'inline-block', background: TEAL, color: 'white', textDecoration: 'none', padding: '12px 28px', borderRadius: '8px', fontWeight: '600', fontSize: '15px' }}>
              Go to Sign In →
            </a>
          </div>
        )}

      </div>
    </div>
  )
}

const lS = { display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '5px' }
const iS = { width: '100%', padding: '12px', fontSize: '15px', border: '1.5px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box', color: '#1e293b', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", outline: 'none' }